import React, { useState } from "react";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DatePicker from "components/forms/date-picker";

import {
  Dialog,
  CircularProgress,
} from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { getHolidays } from "lib/attendance";
import { DialogEditCategory } from "./style";
import moment from "moment";

const DeleteAttendance = ({
  employee,
  attendanceRecord,
  onCancel,
  onDelete,
  deleting,
}) => {
  const [data, setData] = useState({
    employee_id: employee.id,
    employee_name: employee.name,
    date_from: attendanceRecord?.date || "",
    date_to: attendanceRecord?.date || "",
  });

  const handleChange = (field, value) => {
    setData({ ...data, [field]: value });
  };

  const handleGenerateAndDelete = () => {
    const start = moment(data.date_from);
    const end = moment(data.date_to);
    const attendanceList = [];

    // Controllo validità date
    if (!start.isValid() || !end.isValid() || start.isAfter(end)) {
      alert("Controlla le date inserite.");
      return;
    }

    let holidays = getHolidays(start.year());
    if (start.year() !== end.year()) {
      holidays = [...holidays, ...getHolidays(end.year())];
    }

    let current = start.clone();

    while (current.isSameOrBefore(end)) {
      const dayStr = current.format("YYYY-MM-DD");
      const isWeekend = current.isoWeekday() >= 6;
      const isHoliday = holidays.includes(dayStr);

      if (!isWeekend && !isHoliday) {
        attendanceList.push({
          id: 0,
          date: current.format("YYYY-MM-DD"),
          employee_id: data.employee_id,
          employee_name:data.employee_name,
        });
      }

      current.add(1, "days");
    }

    onDelete(attendanceList);
  };

  return (
    <Dialog open={true} onClose={onCancel} fullWidth maxWidth="sm">
      <DialogTitle>{`Gestione Presenze - ${employee.name}`}</DialogTitle>
      <DialogContent>
        <DialogEditCategory>
          {deleting && <CircularProgress />}
          {!deleting && (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                paddingTop: "10px",
              }}
            >
              <div style={{ display: "flex", gap: "20px" }}>
                <DatePicker
                  format={"dd/MM/yyyy"}
                  label="Dal"
                  margin="none"
                  validators={["required"]}
                  onChange={(e) => handleChange("date_from", e)}
                />

                <DatePicker
                  format={"dd/MM/yyyy"}
                  label="Al"
                  margin="none"
                  validators={["required"]}
                  onChange={(e) => handleChange("date_to", e)}
                />
              </div>
            </div>
          )}
        </DialogEditCategory>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Annulla</Button>
        <Button
          variant="contained"
          type="button"
          onClick={handleGenerateAndDelete}
          disabled={ !data.date_from || !data.date_to}
        >
          Elimina
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAttendance;
